module.exports = __webpack_public_path__ + "static/img/device-s1.c6c51b7e.png";